import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip } from '@mui/material';

import { COLORS } from '../../IndividualPlan/tokens';

export function smallGroupTooltip(threshold: number): string {
  return (
    `Small group: fewer than ${threshold} students. One student's score can move this average a lot, ` +
    "so treat year-to-year changes with care. Small groups don't produce findings."
  );
}

export function SmallGroupMarker({ threshold }: { threshold: number }) {
  const title = smallGroupTooltip(threshold);
  return (
    <Tooltip title={title} enterTouchDelay={0} leaveTouchDelay={8000}>
      <Box
        component="span"
        role="img"
        aria-label={title}
        data-testid="small-group-marker"
        sx={{ display: 'inline-flex', verticalAlign: 'middle', color: COLORS.link, ml: 0.5 }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
      </Box>
    </Tooltip>
  );
}
